/**
 * Reorders `current` to match `ids`.
 *
 * Returns `null` unless `ids` names every item exactly once. Reorder endpoints
 * are driven by an optimistic update, and applying a partial or stale id list
 * would drop the unnamed rows from the UI until the next refetch — so the
 * caller skips the optimistic step instead and lets the response settle it.
 */
export function orderByIds<T extends { id: string }>(
  current: readonly T[],
  ids: readonly string[]
): T[] | null {
  const remaining = new Map(current.map((item) => [item?.id, item]))
  const next: T[] = []

  for (const id of ids) {
    const item = remaining.get(id)
    // Missing from the collection, or already claimed earlier in `ids`.
    if (!item) return null

    remaining.delete(id)
    next.push(item)
  }

  return remaining.size === 0 ? next : null
}
